import React from 'react';

/**
 * Shared tutorial banner component for displaying contextual help
 * Renders bold text from **text** markdown syntax
 */
export const TutorialBanner = ({ title, content }) => {
  if (!title && !content) return null;
  
  // Parse content for **bold** markers and render appropriately
  const renderContent = (text) => {
    if (!text) return null;
    
    return text.split(/(\*\*[^*]+\*\*)/).map((part, i) => 
      part.startsWith('**') && part.endsWith('**') 
        ? <strong key={i} className="text-amber-300">{part.slice(2, -2)}</strong>
        : part
    );
  };

  return (
    <div className="bg-amber-500/20 border border-amber-500 rounded-lg p-3 mb-2">
      {title && (
        <p className="text-amber-200 text-sm font-medium">{title}</p>
      )}
      {content && (
        <p className="text-amber-100/80 text-sm mt-1">
          {renderContent(content)}
        </p>
      )}
    </div>
  );
};
